import Command from '../../core/Command';
import OriginalModel from '../../core/OriginalModel';

export default {
  [Command.UNLOCK_DPC]: () => new OriginalModel('55', Command.UNLOCK_DPC, '', [], '', 'AA'),
};
